import styles from './SingleNavItem.scss';

import React from 'react';
import { NavSubItem as NavSubItemType } from 'src/api/contentful/contentTypes.cloverdotcom';
import { TextV2 } from 'src/components/TextV2/TextV2';
import { FlatEntry } from 'src/services/cms/flattenContentful';
import { NavListLink, NavListLinkProps } from '../NavListLink/NavListLink';

export interface SingleNavItemProps extends Omit<NavListLinkProps, 'link' | 'linkClassName'> {
  entry?: FlatEntry<NavSubItemType>;
}

export const SingleNavItem: React.FC<SingleNavItemProps> = ({ entry, ...props }) => {
  if (!entry) return null;

  return (
    <NavListLink link={entry.link} linkClassName={styles.singleNavItemLink} {...props}>
      <TextV2
        value={entry.title}
        tagName="h3"
        className={styles.singleNavItemTitle}
        entry={{ ...entry, field: 'title' }}
        variant="h4-medium"
      />
      <TextV2
        value={entry.blurb}
        className={styles.singleNavItemDescription}
        isMarkdown
        entry={{ ...entry, field: 'blurb' }}
        variant="small"
      />
    </NavListLink>
  );
};

SingleNavItem.displayName = 'SingleNavItem';
